/// <reference path="../ledgeraccount/ReconciliationEntryState.ts" />

// The totals of a journal entry under its lines: both in red while debit and credit differ.
class AccountingEntryTotalsCell extends UITableViewCell
{
    private debitTotalLabel:MUILabel = null;
    private creditTotalLabel:MUILabel = null;

    awakeFromHTML() {
        this.debitTotalLabel = MUIOutlet(this, "debit-total-lbl", "MUILabel");
        this.creditTotalLabel = MUIOutlet(this, "credit-total-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setTotals(debit:number, credit:number) {
        let cf = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter;
        this.debitTotalLabel.text = cf.stringFromNumber(debit ?? 0);
        this.creditTotalLabel.text = cf.stringFromNumber(credit ?? 0);

        let balanced = ReconciliationEntryStateHelper.isBalanced((debit ?? 0) - (credit ?? 0));
        for (let label of [this.debitTotalLabel, this.creditTotalLabel]) {
            if (balanced) MUICoreLayerRemoveStyle(label.layer, "alert");
            else MUICoreLayerAddStyle(label.layer, "alert");
        }
    }
}
